import type { usePreferences } from '@knocklabs/react';

import {
  type LocalPreferences,
  NOTIFICATION_CATEGORIES,
  type NotificationCategory,
  type NotificationChannel,
} from './constants';

export const getRenderedContent = (blocks: unknown[]): string | null => {
  if (!blocks || blocks.length === 0) {
    return null;
  }
  const block = blocks[0] as { rendered?: string };
  return block.rendered ?? null;
};

export const getCategoryFromSource = (source: { categories?: string[] } | null): NotificationCategory => {
  if (!source?.categories?.length) {
    return 'orders';
  }
  const categories = source.categories;
  if (categories.includes('team')) {
    return 'team';
  }
  if (categories.includes('api')) {
    return 'api';
  }

  return 'orders';
};

export const getWorkflowCategories = (tab: NotificationCategory): string[] | undefined => {
  if (tab === 'all') {
    return undefined;
  }

  return [tab];
};

type KnockPreferences = ReturnType<typeof usePreferences>['preferences'];

export const getChannelValueFromKnock = (
  knockPreferences: KnockPreferences,
  knockId: string,
  channel: NotificationChannel,
  type: 'category' | 'workflow',
): boolean => {
  const source = type === 'workflow' ? knockPreferences?.workflows : knockPreferences?.categories;
  const setting = source?.[knockId];

  if (setting === undefined) {
    return true;
  }

  if (typeof setting === 'boolean') {
    return setting;
  }

  if ('channel_types' in setting) {
    const value = setting.channel_types?.[channel];
    return typeof value === 'boolean' ? value : true;
  }

  return true;
};

export const buildLocalPreferencesFromKnock = (knockPreferences: KnockPreferences): LocalPreferences => {
  const local: LocalPreferences = {};
  for (const category of NOTIFICATION_CATEGORIES) {
    for (const notification of category.notifications) {
      local[notification.knockId] = {
        email: getChannelValueFromKnock(knockPreferences, notification.knockId, 'email', notification.type),
        in_app_feed: getChannelValueFromKnock(knockPreferences, notification.knockId, 'in_app_feed', notification.type),
      };
    }
  }
  return local;
};
